export class UserSessionDataForm {

	userDetailsId: number;
	firstName: string;
	lastName: string;
	fullName: string;
	userId: string;
	userRoleId: number;
	userRoleName: string;
	emailId: string;
	userToken: string;
	nda : number;

	constructor() {

	}

}
